<template>
  <div class="max-w-lg mx-auto pb-16">
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <!-- eslint-disable-next-line max-len -->
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    </div>
    <div class="mt-3 text-center sm:mt-5">
      <h2 class="text-lg leading-6 font-medium text-gray-900">Request Access</h2>
      <div class="mt-2">
        <!-- eslint-disable-next-line max-len -->
        <p class="text-sm text-gray-500">Please get in touch with your account owner {{ accountOwnerEmail }} to gain access to this application.</p>
      </div>
      <m-button
        @click="$emit('close')"
        class="mt-8 w-full"
      >
        Go back to dashboard
      </m-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'request-access',
  computed: {
    accountOwnerEmail() {
      return this.$store.getters['account/getActiveAccount'].accountOwnerEmail;
    },
  },
};
</script>
